export const paletteTokens = {
  neutral: {
    grey: {
      100: 'rgba(255, 255, 255, 1)',
      125: 'rgba(252, 252, 252, 1)',
      150: 'rgba(245, 245, 245, 1)',
      200: 'rgba(240, 240, 240, 1)',
      250: 'rgba(233, 233, 233, 1)',
      300: 'rgba(225, 225, 225, 1)',
      350: 'rgba(216, 216, 216, 1)',
      400: 'rgba(204, 204, 204, 1)',
      450: 'rgba(171, 171, 171, 1)',
      500: 'rgba(130, 130, 130, 1)',
      550: 'rgba(104, 104, 104, 1)',
      600: 'rgba(81, 81, 81, 1)',
      650: 'rgba(56, 56, 56, 1)',
      700: 'rgba(48, 48, 48, 1)',
      750: 'rgba(43, 43, 43, 1)',
      800: 'rgba(35, 35, 35, 1)',
      850: 'rgba(28, 28, 28, 1)',
      900: 'rgba(20, 20, 20, 1)',
      925: 'rgba(14, 14, 14, 1)',
      950: 'rgba(0, 0, 0, 1)',
    },
    lightAlpha: {
      100: 'rgba(255, 255, 255, 1)',
      150: 'rgba(255, 255, 255, 0.8)',
      200: 'rgba(255, 255, 255, 0.7)',
      250: 'rgba(255, 255, 255, 0.5)',
      300: 'rgba(255, 255, 255, 0.4)',
      350: 'rgba(255, 255, 255, 0.4)',
      400: 'rgba(255, 255, 255, 0.3)',
      450: 'rgba(255, 255, 255, 0.2)',
      500: 'rgba(255, 255, 255, 0.15)',
      550: 'rgba(255, 255, 255, 0.12)',
      600: 'rgba(255, 255, 255, 0.08)',
      650: 'rgba(255, 255, 255, 0.04)',
      700: 'rgba(255, 255, 255, 0.02)',
    },
    darkAlpha: {
      100: 'rgba(0, 0, 0, 1)',
      150: 'rgba(0, 0, 0, 0.8)',
      200: 'rgba(0, 0, 0, 0.7)',
      250: 'rgba(0, 0, 0, 0.5)',
      300: 'rgba(0, 0, 0, 0.4)',
      350: 'rgba(0, 0, 0, 0.35)',
      400: 'rgba(0, 0, 0, 0.3)',
      450: 'rgba(0, 0, 0, 0.2)',
      500: 'rgba(0, 0, 0, 0.15)',
      550: 'rgba(0, 0, 0, 0.12)',
      600: 'rgba(0, 0, 0, 0.08)',
      650: 'rgba(0, 0, 0, 0.04)',
      700: 'rgba(0, 0, 0, 0.02)',
    },
  },
  tint: {
    orange: {
      100: 'rgba(254, 241, 235, 1)',
      150: 'rgba(253, 234, 225, 1)',
      200: 'rgba(251, 214, 195, 1)',
      250: 'rgba(247, 173, 135, 1)',
      300: 'rgba(245, 145, 95, 1)',
      350: 'rgba(242, 118, 55, 1)',
    },
    coral: {
      100: 'rgba(255, 243, 240, 1)',
      150: 'rgba(255, 237, 233, 1)',
      200: 'rgba(254, 218, 211, 1)',
      250: 'rgba(253, 182, 167, 1)',
      300: 'rgba(253, 157, 138, 1)',
      350: 'rgba(252, 133, 109, 1)',
    },
    yellow: {
      100: 'rgba(253, 250, 235, 1)',
      150: 'rgba(253, 248, 224, 1)',
      200: 'rgba(251, 240, 194, 1)',
      250: 'rgba(246, 225, 133, 1)',
      300: 'rgba(243, 215, 92, 1)',
      350: 'rgba(240, 205, 51, 1)',
    },
    purple: {
      100: 'rgba(246, 238, 255, 1)',
      150: 'rgba(242, 229, 255, 1)',
      200: 'rgba(229, 203, 254, 1)',
      250: 'rgba(202, 151, 254, 1)',
      300: 'rgba(185, 117, 253, 1)',
      350: 'rgba(167, 82, 253, 1)',
    },
    pink: {
      100: 'rgba(255, 241, 254, 1)',
      150: 'rgba(255, 235, 254, 1)',
      200: 'rgba(254, 214, 252, 1)',
      250: 'rgba(254, 173, 250, 1)',
      300: 'rgba(253, 146, 248, 1)',
      350: 'rgba(253, 119, 246, 1)',
    },
    maroon: {
      100: 'rgba(253, 237, 244, 1)',
      150: 'rgba(253, 228, 239, 1)',
      200: 'rgba(251, 201, 223, 1)',
      250: 'rgba(246, 147, 192, 1)',
      300: 'rgba(243, 111, 171, 1)',
      350: 'rgba(240, 75, 150, 1)',
    },
    blue: {
      100: 'rgba(236, 245, 251, 1)',
      150: 'rgba(226, 240, 249, 1)',
      200: 'rgba(197, 224, 243, 1)',
      250: 'rgba(139, 194, 232, 1)',
      300: 'rgba(100, 173, 224, 1)',
      350: 'rgba(61, 153, 216, 1)',
    },
  },
  alert: {
    positive: {
      100: 'rgba(233, 249, 242, 1)',
      150: 'rgba(214, 239, 228, 1)',
      200: 'rgba(188, 236, 215, 1)',
      250: 'rgba(122, 218, 176, 1)',
      300: 'rgba(77, 205, 149, 1)',
      350: 'rgba(33, 193, 123, 1)',
      400: 'rgba(70, 124, 75, 1)',
      450: 'rgba(56, 103, 65, 1)',
      500: 'rgba(47, 89, 58, 1)',
      550: 'rgba(37, 75, 51, 1)',
      600: 'rgba(23, 54, 40, 1)',
    },
    notice: {
      100: 'rgba(255, 246, 230, 1)',
      150: 'rgba(255, 239, 210, 1)',
      200: 'rgba(255, 229, 180, 1)',
      250: 'rgba(254, 202, 105, 1)',
      300: 'rgba(254, 185, 55, 1)',
      350: 'rgba(254, 167, 5, 1)',
      400: 'rgba(213, 140, 4, 1)',
      450: 'rgba(180, 116, 6, 1)',
      500: 'rgba(158, 100, 7, 1)',
      550: 'rgba(136, 83, 8, 1)',
      600: 'rgba(103, 59, 10, 1)',
    },
    negative: {
      100: 'rgba(252, 233, 236, 1)',
      150: 'rgba(251, 222, 226, 1)',
      200: 'rgba(246, 188, 197, 1)',
      250: 'rgba(255, 115, 115, 1)',
      300: 'rgba(236, 74, 74, 1)',
      350: 'rgba(209, 37, 37, 1)',
      400: 'rgba(174, 26, 26, 1)',
      450: 'rgba(149, 28, 30, 1)',
      500: 'rgba(132, 29, 33, 1)',
      550: 'rgba(116, 30, 36, 1)',
      600: 'rgba(83, 29, 36, 1)',
    },
    informative: {
      100: 'rgba(235, 240, 254, 1)',
      150: 'rgba(226, 233, 253, 1)',
      200: 'rgba(196, 211, 251, 1)',
      250: 'rgba(137, 167, 247, 1)',
      300: 'rgba(98, 137, 244, 1)',
      350: 'rgba(59, 108, 241, 1)',
      400: 'rgba(44, 87, 202, 1)',
      450: 'rgba(40, 75, 167, 1)',
      500: 'rgba(38, 67, 144, 1)',
      550: 'rgba(36, 58, 121, 1)',
      600: 'rgba(32, 46, 86, 1)',
    },
  },
  brand: {
    primary: {
      25: 'rgba(102, 204, 204, 0.15)',
      50: 'rgba(102, 204, 204, 0.3)',
      100: 'rgba(102, 204, 204, 1)',
      150: 'rgba(64, 191, 191, 1)',
      200: 'rgba(20, 128, 128, 1)',
      250: 'rgba(25, 97, 97, 1)',
    },
    secondary: {
      10: 'rgba(249, 251, 251, 1)',
      20: 'rgba(244, 249, 249, 1)',
      30: 'rgba(235, 244, 244, 1)',
      40: 'rgba(223, 232, 232, 1)',
      50: 'rgba(204, 213, 214, 1)',
      60: 'rgba(165, 183, 185, 1)',
      70: 'rgba(77, 109, 112, 1)',
      80: 'rgba(52, 89, 92, 1)',
      90: 'rgba(26, 68, 71, 1)',
      100: 'rgba(1, 47, 51, 1)',
      200: 'rgba(1, 37, 40, 1)',
    },
    tertiary: {
      10: 'rgba(255, 247, 242, 1)',
      25: 'rgba(255, 231, 217, 1)',
      50: 'rgba(255, 206, 178, 1)',
      100: 'rgba(255, 92, 0, 1)',
      150: 'rgba(229, 83, 0, 1)',
    },
  },
  pro: {
    primary: {
      15: 'rgba(121, 91, 222, 0.15)',
      50: 'rgba(121, 91, 222, 0.5)',
      100: 'rgba(121, 91, 222, 1)',
      150: 'rgba(109, 73, 223, 1)',
      200: 'rgba(87, 60, 173, 1)',
      250: 'rgba(68, 48, 133, 1)',
    },
    secondary: {
      10: 'rgba(247, 244, 250, 1)',
      25: 'rgba(244, 241, 248, 1)',
      50: 'rgba(239, 236, 244, 1)',
      60: 'rgba(229, 225, 236, 1)',
      65: 'rgba(208, 201, 221, 1)',
      70: 'rgba(79, 64, 110, 1)',
      80: 'rgba(65, 50, 97, 1)',
      90: 'rgba(51, 35, 84, 1)',
      100: 'rgba(32, 19, 59, 1)',
      200: 'rgba(16, 0, 49, 1)',
    },
  },
  dynamicContrast: { primary: { 100: 'rgba(35, 35, 35, 1)' } },
};
